import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { RowAccessKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GridFilter, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";
import { RowAccessComponent } from "src/app/gnr/row-access/row-access.component";
import { Warehouse } from "../../models/warehouse.model";
import { WarehouseFormComponent } from "../warehouse-form/warehouse-form.component";

@Component({
  selector: "ngx-warehouse-list",
  templateUrl: "./warehouse-list.component.html",
  styleUrls: ["./warehouse-list.component.scss"],
})
export class WarehouseListComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  editingName: {
    name: string;
  };
  HasRowAccess: boolean;
  private sub: any;
  constructor(private lookupservice: LookupService, private missetup: MisSetupService) {
    super();
    this.inputEditorform = WarehouseFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    if (this.HasRowAccess === undefined) {
      this.HasRowAccess = this.missetup.getboolean("GNR", "HasRowAccess");
    }
    this.apiName = "Warehouse";
    this.areaName = "Inventory";
    this.label = this.translate("ClientApp.BackOffice.INV.Warehouse.Warehouse");
    this.setactions();
  }
  setactions() {
    if (this.HasRowAccess === true)
      this.actions = [
        {
          name: "RowAccess",
          disabled: false,
          displayName: "دسترسی در ردیف",
          iconName: "icon-users",
          apiName: "Warehouse/RowAccess",
          areaName: "Inventory",
          requireSelectedrows: true,
          Form_Component: RowAccessComponent,
          permission: Permission.samePermission,
        },
      ];
  }
  onActionClick(action: EntityListAction, onRowSelected: Warehouse, onRowsSelected: Warehouse[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    if (action.name === "RowAccess") {
      let ids: number[] = [];
      if (onRowsSelected != null && onRowsSelected.length > 0) {
        onRowsSelected.forEach((x) => ids.push(x.Id));
      } else ids.push(onRowSelected.Id);
      this.lookupservice
        .getLookupbyCode("Security", "RowAccess", RowAccessKind.Warehouse)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.dialogService
              .open(
                action.Form_Component,
                {
                  SelectedRows: ids,
                  RowKindId: x.Id,
                },
                {
                  autoFocus: true,
                  closeOnClickOutside: false,
                }
              )
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((model: GridFilter[]) => {});
          },
          (error) => {}
        );
    }
  }
}
